// -------------------- Asynchronously fetches and filters delivery weeks, then initializes the UI tabs starts ------------------------ //
async function loadDeliveryWeeks() {
  try {
    const [weeksRes, cartRes] = await Promise.all([
      fetch(window.ChinukiConfig.apiBaseUrl + '/b2c/display/weekly/dishes/'),
      fetch('/cart.js')
    ]);

    if (!weeksRes.ok) throw new Error(`HTTP error! status: ${weeksRes.status}`);

    const data = await weeksRes.json();
    const cart = await cartRes.json();

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Sort weeks by date
    const sortedWeeks = [...data.weeks].sort(
      (a, b) => new Date(a.delivery_date) - new Date(b.delivery_date)
    );

    // Find index of first week that is today or future
    const currentIndex = sortedWeeks.findIndex(
      week => {
        const deliveryDate = new Date(week.delivery_date);
        deliveryDate.setHours(0, 0, 0, 0);
        return deliveryDate >= today;
      }
    );

    // If all dates are in past, just return last 3
    if (currentIndex === -1) {
      const lastThree = sortedWeeks.slice(-3);
      const formatted = lastThree.map((week, index) => ({
        delivery_date: week.delivery_date,
        delivery_label: week.label,
        products: week.dishes || [],
        index
      }));

      createTabsWithProducts(formatted, cart);
      initializeEventListeners();
      return;
    }

    // Get past weeks (if available)
    const pastWeeks = sortedWeeks.slice(Math.max(0, currentIndex - 2), currentIndex);

    // Get today + all future weeks
    const futureWeeks = sortedWeeks.slice(currentIndex);

    // Merge both
    const selectedWeeks = [...pastWeeks, ...futureWeeks].map((week, index) => ({
      delivery_date: week.delivery_date,
      delivery_label: formatGermanRangeLabel(week.label),
      products: week.dishes || [],
      index
    }));

    createTabsWithProducts(selectedWeeks, cart);
    initializeEventListeners();

  } catch (err) {
    console.error('API Error:', err);
  }
}

function formatGermanRangeLabel(label) {
  const match = label.match(/(\d{1,2})\.\s*\/\s*(\d{1,2})\.\s*(\w+)\s*(\d{4})/);
  if (!match) return label;

  const [, day1, day2, month, year] = match;
  const monthIndex = new Date(`${month} 1, ${year}`).getMonth();

  if (isNaN(monthIndex)) {
    return label;
  }

  const germanMonth = new Intl.DateTimeFormat('de-DE', {
    month: 'long'
  }).format(new Date(year, monthIndex, 1));

  return `${day1}. / ${day2}. ${germanMonth} ${year}`;
}

// -------------------- Asynchronously fetches and filters delivery weeks, then initializes the UI tabs ends ------------------------ //

const tabsContainer = document.getElementById('tabs');
const tabContentsWrapper = document.querySelector('.tab-contents');

// Create spacer tab at the start
const spacerTabStart = document.createElement('button');
spacerTabStart.className = 'tab spacer';
spacerTabStart.setAttribute('aria-hidden', 'true');
tabsContainer.appendChild(spacerTabStart);


// --------------------- function to create tabs for each delivery week along with their product carousels starts -------------------- //
function createTabsWithProducts(weeks, cart = null) {
  weeks.forEach((week, index) => {
    // Create tab button
    const tab = document.createElement('button');
    tab.className = 'tab';
    tab.setAttribute('data-delivery-date', week.delivery_date);
    tab.dataset.tab = index;
    tab.innerHTML = `Gerichte der Lieferung am: <date>${week.delivery_label}</date>`;
    tab.setAttribute('role', 'tab');
    tab.setAttribute('aria-controls', `tab-content-${index}`);
    tabsContainer.appendChild(tab);

    // Create tab content
    const tabContent = document.createElement('div');
    tabContent.className = 'tab-content';
    tabContent.dataset.content = index;
    tabContent.id = `tab-content-${index}`;
    tabContent.setAttribute('role', 'tabpanel');

    const carouselWrapper = document.createElement('div');
    carouselWrapper.className = 'tab-content-carousel';
    const carousel = document.createElement('div');
    carousel.className = 'carousel';
    carouselWrapper.appendChild(carousel);


    // Append products to carousel
    week.products.forEach(prod => {
      const productWeight = prod.metafields?.weight ?? '280g';
      const rawCategories = prod.metafields?.categories;
      const productCategory = (Array.isArray(rawCategories) ? rawCategories : [])
        .flatMap(item => String(item || '').split(','))
        .map(item => item.trim())
        .filter(Boolean);
      const dishType = prod.metafields?.dish_type || '';
      const dishColor = prod.metafields?.dish_color;
      const fontColor = prod.metafields?.font_color;

      const categoryHTML = productCategory.map(cat => {
        return `<div class="tag product-category" style="background-color: ${dishColor};">${cat}</div>`;
      }).join('');

      const cell = document.createElement('div');
      cell.className = 'carousel-cell';
      cell.innerHTML = `
        <div class="product-card">
          <div class="product-card-wrapper" style="--after-bg: ${dishColor};">
            <div class="product-image" data-product-handle="${prod.handle}" data-product-weight="${productWeight}" data-dish-color="${dishColor}" data-product-price="${prod.price_with_tax}">
              <a href="javascript:;">
                <img src="${prod.image}" alt="${prod.product_title}" height="" width="" />
              </a>
              <div class="product-detail-trigger" data-product-handle="${prod.handle}" data-product-weight="${productWeight}" data-dish-color="${dishColor}" data-product-price="${prod.price_with_tax}">Details</div>
              <div class="product-for-use">
                <div class="product-category-wrapper" style="display: flex; gap: 4px; flex-wrap: wrap;">
                  ${categoryHTML}
                </div>
                <div class="tag-icon">
                  ${dishType === 'vegan'
          ? `
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                          width="34.536" height="31.308" viewBox="0 0 34.536 31.308">
                          <defs>
                            <clipPath id="clip-path">
                              <rect width="34.536" height="31.308" fill="${dishColor}"/>
                            </clipPath>
                          </defs>
                          <g clip-path="url(#clip-path)">
                            <path d="M31.893,8.226C15.491,8.144,6.7,16.154,5.938,32.7a.166.166,0,0,1-.331.02
                            34.667,34.667,0,0,1,.72-14.617c4.358-14.15,20.9-16.02,32.63-11.548a.842.842,0,0,1,.233,1.423
                            c-9.164,7.644-7.919,28.523-30.2,19.476
                            3.463-11.283,10.6-18.3,22.9-19.232"
                            fill="${dishColor}" fill-rule="evenodd"/>
                          </g>
                        </svg>
                      `
          : ''
        }
                </div>
              </div>
              <div class="product-content">
                <div class="product-by">
                  <img src="https://cdn.shopify.com/s/files/1/0681/2804/7414/files/logo-img1.png?v=1767357995" alt="product by" height="" width="" />
                </div>
                <h4 class="dish-title" style="color: ${fontColor};">${prod.product_title}</h4>
              </div>
            </div>
          </div>
          <div class="product-cta" data-variant-id="${prod.variant_id}">
            <button class="cta-popup-btn" data-variant-id="${prod.variant_id}" data-product-weight="${productWeight}" data-dish-color="${dishColor}" data-product-price="${prod.price_with_tax}">
              Hinzufügen
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                  <g id="Group_1280" data-name="Group 1280" transform="translate(-1040.5 -1890.5)">
                    <line id="Line_119" data-name="Line 119" y2="20" transform="translate(1050.5 1890.5)" fill="none" stroke="#fff" stroke-width="2"/>
                    <line id="Line_120" data-name="Line 120" y2="20" transform="translate(1060.5 1900.5) rotate(90)" fill="none" stroke="#fff" stroke-width="2"/>
                  </g>
                </svg>
              </span>
            </button>
            <div class="qty-wrapper">
              <div class="qty-box">
                <div class="qty-btn button-minus" data-variant-id="${prod.variant_id}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="2" viewBox="0 0 20 2">
                    <line id="Line_120" data-name="Line 120" y2="20" transform="translate(20 1) rotate(90)" fill="none" stroke="#35437c" stroke-width="2"/>
                  </svg>
                </div>
                <div class="qty-image">
                  <img src="https://cdn.shopify.com/s/files/1/0681/2804/7414/files/qty-cart.svg?v=1767698038" alt="qty cart" height="" width="" />
                </div>
                <div class="qty-btn button-plus" data-variant-id="${prod.variant_id}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                    <g id="Group_1280" data-name="Group 1280" transform="translate(-1040.5 -1890.5)">
                      <line id="Line_119" data-name="Line 119" y2="20" transform="translate(1050.5 1890.5)" fill="none" stroke="#35437c" stroke-width="2"/>
                      <line id="Line_120" data-name="Line 120" y2="20" transform="translate(1060.5 1900.5) rotate(90)" fill="none" stroke="#35437c" stroke-width="2"/>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
      carousel.appendChild(cell);
    });

    // Create popup (moved outside loop as it's static; customize per week if needed)
    const popupWrapper = document.createElement('div');
    popupWrapper.classList.add('product-item-popup');
    popupWrapper.innerHTML = getPopupHTML();
    carouselWrapper.appendChild(popupWrapper);

    tabContent.appendChild(carouselWrapper);

    // Add CTA button
    const tabCta = document.createElement('div');
    tabCta.classList.add('tab-cta');
    tabCta.innerHTML = `<a href="" class="tab-button">Jetzt Gerichte auswählen</a>`;
    tabContent.appendChild(tabCta);

    tabContentsWrapper.appendChild(tabContent);
  });

  // Create spacer tab at the end
  const spacerTabEnd = document.createElement('button');
  spacerTabEnd.className = 'tab spacer';
  spacerTabEnd.setAttribute('aria-hidden', 'true');
  tabsContainer.appendChild(spacerTabEnd);

  const prevBtn = document.getElementById('prev-week');
  const nextBtn = document.getElementById('next-week');

  if (weeks.length > 0) {
    prevBtn.style.display = 'block';
    nextBtn.style.display = 'block';
  }

  updateActiveTabs(weeks, cart);

  setTimeout(() => {
    applyMatchHeight();
  }, 300);
}

function getPopupHTML() {
  return `
    <div class="popup-inner">
      <div class="product-name">
        <h2>Ihre Gerichte</h2>
        <img src="https://cdn.shopify.com/s/files/1/0681/2804/7414/files/qty-cart.svg?v=1767698038" alt="qty cart" />
        <button class="mobile-cart-detail visible-mobile" id="mobile-cart">
          <svg xmlns="http://www.w3.org/2000/svg" width="23.658" height="13.999" viewBox="0 0 23.658 13.999">
            <g id="drop_down" data-name="drop down" transform="translate(21.537 11.877) rotate(180)">
              <line id="Line_5" data-name="Line 5" y1="9.756" x2="9.459" transform="translate(0 0)" fill="none" stroke="#e19f8f" stroke-linecap="round" stroke-width="3"/>
              <line id="Line_6" data-name="Line 6" x1="9.737" y1="9.756" transform="translate(9.679 0)" fill="none" stroke="#e19f8f" stroke-linecap="round" stroke-width="3"/>
            </g>
          </svg>
          <span>Details anzeigen</span>
        </button>
      </div>
      <div class="popup-mobile-info-cta">
        <span>Ausgewählte Portionen</span>
        <span>0</span>
      </div>
      <div class="popup-mobile-wrapper">
        <div class="popup-product-info">
          <div class="info-popup-trigger">Hilfe zur Portionenanzahl <span>?</span></div>
          <div class="model-product-info">
            <div class="model-product-info-block">
              <button class="drawer-modal-close">
                <svg xmlns="http://www.w3.org/2000/svg" width="46.866" height="47.957" viewBox="0 0 46.866 47.957">
                  <g id="Group_1226" data-name="Group 1226" transform="translate(-1611.694 -741.608)">
                    <g id="Component_5_7" data-name="Component 5 – 7" transform="translate(1614.521 744.437)">
                      <g id="drop_down" data-name="drop down">
                        <line id="Line_5" data-name="Line 5" x2="20.077" y2="21.15" fill="none" stroke="#35437C" stroke-linecap="round" stroke-width="4"/>
                        <line id="Line_6" data-name="Line 6" x1="20.667" y2="21.15" transform="translate(20.543)" fill="none" stroke="#35437C" stroke-linecap="round" stroke-width="4"/>
                      </g>
                    </g>
                    <g id="Component_5_8" data-name="Component 5 – 8" transform="translate(1614.521 765.587)">
                      <g id="drop_down-2" data-name="drop down">
                        <line id="Line_5-2" data-name="Line 5" y1="21.15" x2="20.077" fill="none" stroke="#35437C" stroke-linecap="round" stroke-width="4"/>
                        <line id="Line_6-2" data-name="Line 6" x1="20.667" y1="21.15" transform="translate(20.543)" fill="none" stroke="#35437C" stroke-linecap="round" stroke-width="4"/>
                      </g>
                    </g>
                  </g>
                </svg>
              </button>
              <div class="product-info-content">
                <h2 class="popup-title">Portionenanzahl</h2>
                <div class="item-cart">
                  <div class="item-img">
                    <img src="https://cdn.shopify.com/s/files/1/0681/2804/7414/files/product-item.png?v=1767778087" alt="item" />
                  </div>
                  <div class="item-content">
                    <div class="product-cart-item">
                      <span class="qty">1X</span> Chinuki Portion* = <span class="total">280g</span>
                    </div>
                  </div>       
                </div>                 
                <div class="protine-info protine-box">
                  <h4>Empfohlene Portionsgrößen</h4>
                  <p>(laut DGE für die warme Mittagsmahlzeit)</p>
                  <div class="protine-list">
                    <div class="protine-items">
                      <div class="item-image">
                        <img src="https://cdn.shopify.com/s/files/1/0681/2804/7414/files/protine-item.png?v=1767778403" alt="item" />
                      </div>
                      <div class="item-image-info">
                        <div class="suggest-age"><span class="age">U3</span>unter 3 Jahre</div>
                      </div>
                      <p class="protine-count">~150-200g</p>
                    </div>  
                    <div class="protine-items">
                      <div class="item-image">
                        <img src="https://cdn.shopify.com/s/files/1/0681/2804/7414/files/protine-item.png?v=1767778403" alt="item" />
                      </div>
                      <div class="item-image-info">
                        <div class="suggest-age"><span class="age">U3</span>3-6 Jahre</div>
                      </div>
                      <p class="protine-count">~200-250g</p>
                    </div>  
                    <div class="protine-items">
                      <div class="item-image">
                        <img src="https://cdn.shopify.com/s/files/1/0681/2804/7414/files/protine-item.png?v=1767778403" alt="item" />
                      </div>
                      <div class="item-image-info">
                        <div class="suggest-age"><span class="age">U3</span>Schulkinder</div>
                      </div>
                      <p class="protine-count">~250-300g</p>
                    </div>  
                    <div class="protine-items">
                      <div class="item-image">
                        <img src="https://cdn.shopify.com/s/files/1/0681/2804/7414/files/protine-item.png?v=1767778403" alt="item" />
                      </div>
                      <div class="item-image-info">
                        <div class="suggest-age"><span class="age blank"></span>Erwachsener</div>
                      </div>
                      <p class="protine-count">~400-500g</p>
                    </div>  
                  </div>
                </div>
                <div class="protine-pending protine-box">
                  <h4>Kalkulationsbeispiel</h4>
                  <div class="protine-pending-list">
                    <div class="protine-pending-image">
                      <img src="https://cdn.shopify.com/s/files/1/0681/2804/7414/files/pending-protine.png?v=1767778849" alt="pending protine" />
                    </div>
                    <div class="protine-pending-data">
                      <div class="pending-data-list">
                        <div class="data-count"><p>Kind <span class="suggest-age-pending">U3</span></p></div>
                        <div class="data-pending"><p>~170g</p></div>
                      </div>
                      <div class="pending-data-list">
                        <div class="data-count"><p>Kind <span class="suggest-age-pending">U6</span></p></div>
                        <div class="data-pending"><p>~270g</p></div>
                      </div>
                      <div class="pending-data-list">
                        <div class="data-count"><p>Erwachsener</p></div>
                        <div class="data-pending"><p>~400g</p></div>
                      </div>
                      <div class="pending-data-list total">
                        <div class="data-count"><p>Summe Portionen</p></div>
                        <div class="data-pending"><p>~840g</p></div>
                      </div>
                    </div>
                  </div>
                  <div class="best-buy">
                    <div class="protine-pending-image">
                      <img src="https://cdn.shopify.com/s/files/1/0681/2804/7414/files/pending-protine.png?v=1767778849" alt="pending protine" />
                    </div>
                    <div class="protine-pending-data">
                      <p>Bestellmenge pro Gericht*</p>
                      <div class="total-protine">
                        <span class="pending-qty">3x</span><span class="pending-price"> 280g</span> = <span class="pending-totel">840g</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="note">
                  <p>* Mindestportionanzahl pro Gericht: 3x Portionen</p>
                </div>
                <div class="protine-cta">
                  <button class="protine-button">Bestätigen</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="product-cart-wrapper"></div> 
      </div>
      <div class="product-popup-summary">
        <div class="cart-process">
          <p class="process-pending-count"></p>
          <div class="cart-process-bar">
            <div class="min-order process-bar">
              <label>Mindestbestellmenge</label>
              <div class="progress">
                <div class="act-process"></div>
              </div>
            </div>
            <div class="free-shipping process-bar">
              <label>5€ Versandkostenrabatt</label>
              <div class="progress">
                <div class="act-process"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="cart-item-info">
          <div class="total-number">
            <p>Gesamte Portionenanzahl</p>
            <p class="total-number-count total-portion-count"></p>
          </div>
          <div class="total-number total-number-qty">
            <p>Gesamtgewicht</p>
            <p class="total-number-count total-weight"></p>
          </div>
          
          <div class="total-price-info total-price-sub">
            <p>Zwischensumme</p>
            <p class="total-price"></p>
          </div>
          <div class="total-price-info shipping-cost">
            <p>Versandkosten</p>
            <p class="total-price">€ <span>0,00</span></p>
          </div>
          
          <div class="total-price-info final-price">
            <p>Gesamt</p>
            <p class="total-price">€ <span class="calculated-price">0,00</span></p>
          </div>
          <div class="total-price-info vat">
            <p>inkl. 7% MwSt.</p>
            <p class="total-price">€ <span class="tax-price">0,00</span></p>
          </div>
        </div>
        <div class="atc-btn-block">
          <button class="atc-btn">Bestellen</button>
        </div>
      </div>
    </div>
  `;
}

// --------------------- function to create tabs for each delivery week along with their product carousels ends -------------------- //


// ---------------- enable or disable delivery tabs based on a calculated cutoff time start ------------------- //
function updateActiveTabs(weeks, cart) {
  const now = new Date();
  let firstEnabledIndex = -1;
  let matchingTab = null;

  weeks.forEach((week, index) => {
    const deliveryDate = new Date(week.delivery_date);
    const cutoff = new Date(deliveryDate);
    cutoff.setDate(cutoff.getDate() - ((cutoff.getDay() + 6) % 7));
    cutoff.setHours(9, 0, 0, 0);

    const tab = tabsContainer.querySelector(`.tab[data-tab="${index}"]`);
    const content = document.querySelector(`.tab-content[data-content="${index}"]`);
    if (now < cutoff) {
      tab.disabled = false;
      if (firstEnabledIndex === -1) firstEnabledIndex = index;
    } else {
      content.classList.add('past-delivery');
      tab.classList.add('is-disabled');
      tab.setAttribute('aria-disabled', 'true');
    }
  });

  // Determine which tab to activate
  if (cart.items.length > 0) {
    const deliveryDate = cart.items[0].properties?._delivery_date;
    const candidate = tabsContainer.querySelector(`.tab[data-delivery-date="${deliveryDate}"]`);

    if (candidate && !candidate.classList.contains('is-disabled')) {
      matchingTab = candidate;
    } else if (candidate && candidate.classList.contains('is-disabled')) {
      clearCart();
    }
  }

  if (matchingTab) {
    document.querySelectorAll('.tab').forEach(t => {
      t.classList.remove('active');
      t.removeAttribute('aria-selected');
    });
    document.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));

    // Activate
    matchingTab.classList.add('active');
    matchingTab.setAttribute('aria-selected', 'true');
    matchingTab.classList.add('cart-has-item');

    const tabId = matchingTab.dataset.tab;
    const activeContent = document.querySelector(`.tab-content[data-content="${tabId}"]`);
    activeContent.classList.add('active');

    centerTab(matchingTab);

    const carousel = activeContent.querySelector('.carousel');
    if (carousel?.flickityInstance) {
      carousel.dataset.restoreIndex = carousel.flickityInstance.selectedIndex;
      carousel.flickityInstance.destroy();
      carousel.flickityInstance = null;
    }
    carousel?.classList.add('no-slider');
    activeContent.querySelector('.tab-cta')?.classList.add('hidden');
    document.body.classList.add('show-ingredient');

    updateCartUI();
  } else if (firstEnabledIndex !== -1) {
    const initialTab = tabsContainer.querySelector(`.tab[data-tab="${firstEnabledIndex}"]`);
    activateTab(initialTab);
  }
}

// ---------------- enable or disable delivery tabs based on a calculated cutoff time end ------------------- //


function centerTab(tab) {
  const containerWidth = tabsContainer.offsetWidth;
  const tabWidth = tab.offsetWidth;
  const tabOffsetLeft = tab.offsetLeft;
  let scrollLeft = tabOffsetLeft - (containerWidth / 2 - tabWidth / 2);
  const maxScroll = tabsContainer.scrollWidth - containerWidth;

  if (scrollLeft < 0) scrollLeft = 0;
  if (scrollLeft > maxScroll) scrollLeft = maxScroll;

  tabsContainer.scrollTo({
    left: scrollLeft,
    behavior: 'smooth'
  });
}

function initCarousel(carousel, initialSlide = 0) {
  if (!carousel) return;

  // Prevent re-initialization if already active
  if (carousel.flickityInstance) {
    carousel.flickityInstance.select(initialSlide, false, true);
    return;
  }

  carousel.flickityInstance = new Flickity(carousel, {
    cellAlign: 'center',
    contain: true,
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false,
    initialIndex: initialSlide,
    imagesLoaded: true
  });

  carousel.classList.add('flickity-enabled');
  applyMatchHeight();

  // Re-run match height and resize after images are loaded
  imagesLoaded(carousel, () => {
    applyMatchHeight();
    carousel.flickityInstance?.resize();
  });
}

function applyMatchHeight() {
  // Target the dish titles inside the currently visible / all product cards
  $('.home-collection .product-card .product-content .dish-title').matchHeight({
    byRow: true
  });
}

function activateTab(tab) {
  if (tab.classList.contains('cart-has-item')) return;
  const id = tab.dataset.tab;
  const currentActiveTab = document.querySelector('.tab.active');
  const currentId = currentActiveTab ? currentActiveTab.dataset.tab : null;
  if (currentId !== null && currentId !== id && currentActiveTab?.classList.contains('cart-has-item')) {
    clearCart();     // Clear cart while tab switching

    const prevTab = document.querySelector(`.tab[data-tab="${currentId}"]`);
    prevTab.classList.remove('cart-has-item');

    const prevContent = document.querySelector(`.tab-content[data-content="${currentId}"]`);
    if (prevContent) {
      const prevCTA = prevContent.querySelector('.tab-cta.hidden');
      if (prevCTA) {
        prevCTA.classList.remove('hidden');
      }
    }
  }

  // Deactivate all tabs and contents
  document.querySelectorAll('.tab').forEach(t => t.classList.remove('active'));
  document.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));

  tab.classList.add('active');
  tab.setAttribute('aria-selected', 'true');

  const activeContent = document.querySelector(`.tab-content[data-content="${id}"]`);
  activeContent.classList.add('active');

  centerTab(tab);
  // Remove active classes from product blocks
  activeContent.querySelectorAll('.active').forEach(el => {
    if (!el.classList.contains('tab')) el.classList.remove('active');
  });

  const carousel = activeContent.querySelector('.carousel');
  if (carousel) {
    carousel.classList.remove('no-slider');
    const savedIndex = parseInt(carousel.dataset.restoreIndex || 0, 10);
    initCarousel(carousel, savedIndex);
  }
}

function initializeEventListeners() {
  const tabs = document.querySelectorAll('.tab[data-tab]');
  const popup = document.getElementById('tab-switch-popup');
  const confirmBtn = document.getElementById('confirm-switch');
  const cancelBtn = document.getElementById('cancel-switch');

  let selectedTab = null;

  tabs.forEach(tab => {
    tab.addEventListener('click', async (e) => {
      e.preventDefault();

      if (tab.classList.contains('active')) return;
      const currentActiveTab = document.querySelector('.tab.active');

      if (currentActiveTab?.classList.contains('cart-has-item')) {
        selectedTab = tab;
        popup.hidden = false;
        body.style.overflow = 'hidden';
      } else {
        activateTab(tab);
      }
    });
  });

  confirmBtn.addEventListener('click', () => {
    if (selectedTab) {
      activateTab(selectedTab);
      selectedTab = null;
    }
    popup.hidden = true;
    body.style.overflow = 'auto';
  });

  cancelBtn.addEventListener('click', () => {
    selectedTab = null;
    popup.hidden = true;
    body.style.overflow = 'auto';
  });


  // Arrow navigation
  function handleArrowNavigation(targetTab) {
    const currentActiveTab = document.querySelector('.tab.active');

    if (currentActiveTab?.classList.contains('cart-has-item')) {
      selectedTab = targetTab;
      popup.hidden = false;
      body.style.overflow = 'hidden';
    } else {
      activateTab(targetTab);
    }
  }

  // Arrow navigation
  document.getElementById('prev-week')?.addEventListener('click', () => {
    const activeIndex = Array.from(tabs).findIndex(t => t.classList.contains('active'));
    if (activeIndex > 0 && !tabs[activeIndex - 1].disabled) {
      handleArrowNavigation(tabs[activeIndex - 1]);
    }
  });

  document.getElementById('next-week')?.addEventListener('click', () => {
    const activeIndex = Array.from(tabs).findIndex(t => t.classList.contains('active'));
    if (activeIndex < tabs.length - 1 && !tabs[activeIndex + 1].disabled) {
      handleArrowNavigation(tabs[activeIndex + 1]);
    }
  });

  // Accordion
  document.addEventListener('click', e => {
    const header = e.target.closest('.accordion-header');
    if (!header) return;

    const currentItem = header.parentElement;
    document.querySelectorAll('.accordion-item').forEach(item => {
      if (item !== currentItem) item.classList.remove('active');
    });
    currentItem.classList.toggle('active');
  });

  // Info popup
  document.addEventListener('click', e => {
    const popupTrigger = e.target.closest('.info-popup-trigger');
    const closeModal = e.target.closest('.drawer-modal-close');

    if (popupTrigger) {
      const popupModal = popupTrigger.closest('.popup-product-info').querySelector('.model-product-info');
      popupModal.classList.add('active');
    }

    if (closeModal) {
      const popupModal = closeModal.closest('.model-product-info');
      popupModal.classList.remove('active');
    }
  });

  document.addEventListener('click', e => {
    const infoConfirmBtn = e.target.closest('.protine-button');
    if (!infoConfirmBtn) return;
    const popup = infoConfirmBtn.closest('.model-product-info.active');
    if (!popup) return;
    popup.classList.remove('active');
  })

  // Click handler for device buttons start
  document.addEventListener('click', e => {
    const btn = e.target.closest('.sources-btn');
    if (!btn) return;

    const container = btn.closest('.device-sources');
    if (!container) return;

    const deviceBtns = document.querySelectorAll('.sources-btn');
    deviceBtns.forEach(b => {
      b.classList.remove('selected');
      b.style.backgroundColor = '';
      b.style.color = '';
    });

    const popupId = btn.getAttribute('data-popup');

    if (popupId === 'with-device') {
      const popup = container.querySelector(`#${popupId}`);
      if (!popup) return;

      popup.classList.add('active');

      const confirmBtn = popup.querySelector('.device-button');

      const confirmHandler = async () => {
        try {
          const res = await fetch('/cart.js');
          if (!res.ok) throw new Error(`Failed to fetch cart: ${res.status}`);
          const cart = await res.json();

          if (cart.items.length > 0) {
            btn.classList.add('selected');
            btn.style.backgroundColor = '#35437c';
            btn.style.color = '#fff';
          }
        } catch (error) {
          console.error('Failed to confirm device selection:', error);
        } finally {
          confirmBtn.removeEventListener('click', confirmHandler);
          popup.classList.remove('active');
        }
      };

      confirmBtn.addEventListener('click', confirmHandler);
    }

    if (popupId === 'without-device') {
      (async () => {
        try {
          const res = await fetch('/cart.js');
          if (!res.ok) throw new Error(`Failed to fetch cart: ${res.status}`);
          const cart = await res.json();

          if (cart.items.length > 0) {
            btn.classList.add('selected');
            btn.style.backgroundColor = '#35437c';
            btn.style.color = '#fff';
          }
        } catch (error) {
          console.error('Failed to select without device:', error);
        } finally {
          container.querySelector(`#${popupId}`)?.classList.remove('active');
        }
      })();
    }
  });

  // Close popup
  document.addEventListener('click', e => {
    const closePopupModal = e.target.closest('.device-popup-close');
    if (!closePopupModal) return;
    const popup = closePopupModal.closest('.device-popup.active');
    if (!popup) return;
    popup.classList.remove('active');
  })


  // Mobile info CTA
  document.addEventListener('click', e => {
    const mobileInfoCTA = e.target.closest('.popup-mobile-info-cta');
    if (!mobileInfoCTA) return;

    document.body.classList.add('mobile-detail-popup-open');
  });

  // Mobile cart toggle
  document.addEventListener('click', e => {
    const mobileCartBtn = e.target.closest('#mobile-cart');
    if (!mobileCartBtn) return;

    // Toggle the class on body
    document.body.classList.toggle('mobile-detail-popup-open');
    const span = mobileCartBtn.querySelector('span');
    if (!span) return;

    if (document.body.classList.contains('mobile-detail-popup-open')) {
      span.textContent = 'Details verbergen';
    } else {
      span.textContent = 'Details anzeigen';
    }
  });

  // ------------- Product detail popup modal functionality starts -----------------//
  document.addEventListener('click', async function (e) {
    const modal = document.getElementById('productModal');
    const modalContent = modal.querySelector('.custom-modal-row');
    const detailBtn = e.target.closest('.product-detail-trigger');
    const productImage = e.target.closest('.product-image');
    const modalCartBtn = e.target.closest('.js-modal-add-to-cart');

    const isDesktop = window.matchMedia('(min-width: 992px)').matches;
    const isMobile = !isDesktop;

    if ((isDesktop && detailBtn) || (isMobile && productImage)) {
      const triggerEl = detailBtn || productImage;
      const productHandle = triggerEl.getAttribute('data-product-handle');
      const productWeight = triggerEl.getAttribute('data-product-weight');
      const dishColor = triggerEl.getAttribute('data-dish-color');
      const productPrice = triggerEl.getAttribute('data-product-price');
      modalContent.innerHTML = '';

      try {
        if (detailBtn) {
          detailBtn.classList.add('loading');
          detailBtn.disabled = true;
        }
        // Fetch product JSON
        const productRes = await fetch(`/products/${productHandle}.js`);
        const productData = await productRes.json();

        // Trigger view_item tracking event
        if (typeof window.chinukiTrack === 'function' && productData) {
          try {
            const firstVariant = productData.variants && productData.variants[0];
            const price = firstVariant ? (parseFloat(firstVariant.price) / 100).toFixed(2) : (parseFloat(productData.price) / 100).toFixed(2);

            const payload = {
              currency: 'EUR',
              value: price,
              items: [{
                item_id: firstVariant ? firstVariant.id.toString() : productData.id.toString(),
                item_name: productData.title,
                price: price,
                quantity: 1
              }]
            };
            window.chinukiTrack('view_item', payload);
          } catch (trackErr) {
            console.error('[chinuki] Error tracking view_item:', trackErr);
          }
        }

        const response = await fetch(`/products/${productHandle}?view=b2c-product-detail`);
        const html = await response.text();

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const detailContainer = tempDiv.querySelector('.custom-modal-row');

        if (detailContainer) {
          modalContent.innerHTML = detailContainer.innerHTML;
          modalContent.setAttribute('data-variant-id', productData.variants[0].id);
          modalContent.setAttribute('data-product-weight', productWeight);
          modalContent.setAttribute('data-dish-color', dishColor);
          modalContent.setAttribute('data-product-price', productPrice);
          const modalImages = modalContent.querySelectorAll('img');
          modalImages.forEach(img => {
            img.loading = 'eager';
            img.onload = () => {
              img.classList.add('loaded');
            };
          });
        }

        if ($('.modal-content-block').find('.jdgm-prev-badge__text').length) {
          let reviewString = $('.modal-content-block').find('.jdgm-prev-badge__text').text();
          reviewString = reviewString.split(" ")[1]
          if (reviewString.includes("No")) {
            var str2_desktop = 'Keine Bewertungen'
          } else {
            var str2_desktop = reviewString + ' Bewertungen'
          }
          $('.modal-content-block').find('.jdgm-prev-badge__text').text(str2_desktop)
        }

        var reciew_button_url = '/products/' + productHandle + '?review-open-form&b2c=true';
        setTimeout(function () {
          $("#productModal .custom-modal-content .jdgm-preview-badge").wrap('<a href="' + reciew_button_url + '"></a>');
          $('.product-detail__valuation').each(function () {
            $(this).html(
              '<a href="' + reciew_button_url + '" class="btn btn--quaternary btn--small">Jetzt bewerten</a>'
            );
          });
        }, 200);

        const activeTabContent = document.querySelector('.tab-content.active');
        const isPastDelivery = activeTabContent?.classList.contains('past-delivery');

        setTimeout(() => {
          const modalAddBtn = modal.querySelector('.js-modal-add-to-cart');

          modal.style.display = 'flex';
          document.body.style.overflow = 'hidden';

          if (isPastDelivery) {
            modalAddBtn.style.opacity = '0.8';
            modalAddBtn.disabled = true;
            modalAddBtn.style.cursor = 'auto';
          } else {
            modalAddBtn.style.opacity = '1';
            modalAddBtn.disabled = false;
            modalAddBtn.style.cursor = 'pointer';
          }

        }, 200)

      } catch (error) {
        console.error('Failed to fetch product!', error);
      } finally {
        if (detailBtn) {
          detailBtn.classList.remove('loading');
          detailBtn.disabled = false;
        }
      }
      return;
    }

    if (modalCartBtn) {
      const variantId = document.querySelector('.custom-modal-row').getAttribute('data-variant-id');
      const productWeight = document.querySelector('.custom-modal-row').getAttribute('data-product-weight');
      const dishColor = document.querySelector('.custom-modal-row').getAttribute('data-dish-color');
      const productPrice = document.querySelector('.custom-modal-row').getAttribute('data-product-price');
      if (!variantId) return;
      try {
        const currentTab = document.querySelector('.tab.active');
        const deliveryDate = currentTab.dataset.deliveryDate;

        modalCartBtn.classList.add('loading');
        modalCartBtn.disabled = true;

        await addToCart(variantId, 3, deliveryDate, productWeight, dishColor, productPrice);

        // UI updates
        const activeTabContent = document.querySelector('.tab-content.active');
        const carousel = activeTabContent?.querySelector('.carousel');

        currentTab?.classList.add('cart-has-item');

        if (carousel?.flickityInstance) {
          carousel.dataset.restoreIndex = carousel.flickityInstance.selectedIndex;
          carousel.flickityInstance.destroy();
          carousel.flickityInstance = null;
        }

        carousel?.classList.add('no-slider');
        document.body.classList.add('show-ingredient');
        modal.style.display = 'none';
        document.body.style.overflow = 'auto';

      } catch (error) {
        console.error('Add to cart failed:', error);
      } finally {
        modalCartBtn.classList.remove('loading');
        modalCartBtn.disabled = false;
      }

      return;
    }

    if (e.target.closest('.custom-modal-close') || e.target.classList.contains('modal-overlay') || e.target.closest('.js-modal-back')) {
      modal.style.display = 'none';
      document.body.style.overflow = 'auto';
    }
  });
  // ------------- Product detail popup modal functionality ends -----------------//

  // ------------- Add to cart, change item quantity, open cart functionality starts -------------------- //
  document.addEventListener('click', async function (e) {
    const cta = e.target.closest('.cta-popup-btn');
    if (cta) {
      cta.disabled = true;
      cta.classList.add('disabled');

      const activeTab = document.querySelector('.tab.active');
      const deliveryDate = activeTab.dataset.deliveryDate;
      const variantId = cta.dataset.variantId;
      const productWeight = cta.dataset.productWeight
      const dishcolor = cta.dataset.dishColor;
      const productPrice = cta.dataset.productPrice;
      if (variantId) await addToCart(variantId, 3, deliveryDate, productWeight, dishcolor, productPrice);

      cta.disabled = false;
      cta.classList.remove('disabled');

      const currentTab = document.querySelector('.tab.active');
      currentTab.classList.add('cart-has-item');

      const carousel = cta.closest('.carousel');
      if (!carousel) return;
      if (carousel.flickityInstance) {
        // Save current slide index
        carousel.dataset.restoreIndex = carousel.flickityInstance.selectedIndex;
        // Destroy Flickity
        carousel.flickityInstance.destroy();
        carousel.flickityInstance = null;
      }

      carousel.classList.add('no-slider');
      cta.parentElement.classList.add('active');
      document.body.classList.add('show-ingredient');

      const activeTabContent = cta.closest('.tab-content.active');
      activeTabContent.querySelector('.tab-cta').classList.add('hidden');
      return;
    }

    const cartQtyBtn = e.target.closest('.qty-plus, .qty-minus');
    if (cartQtyBtn) {
      // Disable the quantity button
      cartQtyBtn.disabled = true;
      cartQtyBtn.classList.add('disabled');
      const line = cartQtyBtn.getAttribute('data-line');
      const cartItem = document.querySelector(`.cart-items[data-line="${line}"]`);
      const input = cartItem.querySelector('input[name="cart-qty"]');
      let qty = parseInt(input.value, 10);

      if (cartQtyBtn.classList.contains('qty-plus')) qty++;
      if (cartQtyBtn.classList.contains('qty-minus')) qty = Math.max(qty - 1, 3);

      await changeCartItemQuantity(line, qty);
      // Re-enable the button
      cartQtyBtn.disabled = false;
      cartQtyBtn.classList.remove('disabled');
      return;
    }

    const removeBtn = e.target.closest('.remove-btn');
    if (removeBtn) {
      removeBtn.classList.add('loading');
      removeBtn.disabled = true;

      const line = removeBtn.getAttribute('data-line');
      await changeCartItemQuantity(line, qty = 0);

      removeBtn.classList.remove('loading');
      removeBtn.disabled = false;
    }

    const productQtyBtn = e.target.closest('.button-minus, .button-plus');
    if (productQtyBtn) {
      // Disable the productQtyBtn
      productQtyBtn.disabled = true;
      productQtyBtn.classList.add('disabled');

      const variantId = productQtyBtn.dataset.variantId;
      if (!variantId) return;

      // Get current cart
      const response = await fetch('/cart.js');
      const cart = await response.json();

      // Find the cart item
      const cartItem = cart.items.find(item => String(item.variant_id) === String(variantId));
      if (!cartItem) return;

      let newQty = cartItem.quantity;

      if (productQtyBtn.classList.contains('button-plus')) {
        newQty += 1;
      } else if (productQtyBtn.classList.contains('button-minus')) {
        newQty = Math.max(3, newQty - 1);
      }

      await changeCartItemQuantity(cartItem.key, newQty);

      // Re-enable the productQtyBtn
      productQtyBtn.disabled = false;
      productQtyBtn.classList.remove('disabled');
      return;
    }


    const tabCtaBtn = e.target.closest('.tab-button');
    if (tabCtaBtn) {
      e.preventDefault();
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();

        // If cart has items → sync UI state properly
        if (cart.items.length > 0) {
          await updateCartUI();
        }
      } catch (err) {
        console.error('Failed to sync cart before opening:', err);
      }
      const activeContent = document.querySelector('.tab-content.active');
      const carousel = activeContent.querySelector('.carousel');
      if (carousel?.flickityInstance) {
        carousel.dataset.restoreIndex = carousel.flickityInstance.selectedIndex;
        carousel.flickityInstance.destroy();
        carousel.flickityInstance = null;
      }

      carousel?.classList.add('no-slider');
      document.body.classList.add('show-ingredient');
      tabCtaBtn.closest('.tab-cta')?.classList.add('hidden');
      return;
    }

  });

  // ------------- Add to cart, change item quantity, open cart functionality ends -------------------- //
}

async function addToCart(variantId, quantity = 3, deliveryDate, productWeight, dishcolor, productPrice) {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity,
        properties: {
          // 'unique_item': String(Date.now()),
          '_delivery_date': deliveryDate,
          '_product_weight': productWeight,
          '_dish_color': dishcolor,
          '_product_price': productPrice
        }
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.description || 'Failed to add to cart');
    }

    updateCartUI();

    if (typeof window.chinukiTrack === 'function') {
      try {
        const cartRes = await fetch('/cart.js');
        if (cartRes.ok) {
          const cartData = await cartRes.json();
          const addedItem = cartData.items.find(item => String(item.variant_id) === String(variantId) || String(item.id) === String(variantId));
          if (addedItem) {
            const itemPrice = parseFloat(addedItem.price) / 100;
            const value = (itemPrice * quantity).toFixed(2);

            const payload = {
              currency: 'EUR',
              value: value,
              items: [{
                item_id: (addedItem.variant_id || addedItem.id).toString(),
                item_name: addedItem.product_title || addedItem.title,
                price: itemPrice.toFixed(2),
                quantity: parseInt(quantity, 10)
              }]
            };
            window.chinukiTrack('add_to_cart', payload);
          }
        }
      } catch (trackErr) {
        console.error('Error tracking add to cart:', trackErr);
      }
    }

  } catch (error) {
    console.error('Error adding product to cart:', error);
  }
}

var finalTaxPriceTotal = 0
async function updateCartUI() {
  finalTaxPriceTotal = 0;
  try {
    const activeTabContent = document.querySelector('.tab-content.active');
    const progressPending = activeTabContent.querySelector('.process-pending-count');
    const BAR_LIMIT = 12;
    const SHIPPING_LIMIT = BAR_LIMIT * 2;
    const minOrderProgress = activeTabContent.querySelector('.min-order .act-process');
    const freeShippingProgress = activeTabContent.querySelector('.free-shipping .act-process');
    const DISCOUNT = 5; // 5€ discount for orders above SHIPPING_LIMIT

    const res = await fetch('/cart.js');
    const cart = await res.json();

    const cartWrapper = activeTabContent.querySelector('.product-cart-wrapper');
    cartWrapper.innerHTML = ''; // Clear existing items
    let totalPortions = 0;

    const cartVariantIds = new Set(
      cart.items.map(item => String(item.variant_id))
    );
    activeTabContent.querySelectorAll('.product-cta').forEach(cta => {
      const variantId = cta.dataset.variantId;
      if (cartVariantIds.has(String(variantId))) {
        cta.classList.add('active');
      } else {
        cta.classList.remove('active');
      }
    });

    var finalTaxPrice = 0;
    var finalTax = 0;
    cart.items.forEach(item => {
      const itemPriceWitOutTax1 = Math.round(((item.price / 100) * item.quantity) * 0.07 * 100) / 100;

      finalTaxPriceTotal += itemPriceWitOutTax1;
    });

    cart.items.forEach(item => {
      totalPortions += item.quantity;
      const productWeight = item.properties?._product_weight;
      const dishColor = item.properties?._dish_color;
      const rawPrice = item.properties?._product_price;
      const itemPriceWithTax = rawPrice && !isNaN(parseFloat(rawPrice)) ? parseFloat(rawPrice) : ((item.price / 100) * 1.07);
      const itemOrignalPrice = (item.price / 100).toFixed(2);
      const itemPriceWitOutTax = Math.round(((item.price / 100) * item.quantity) * 0.07 * 100) / 100;
      finalTaxPrice += itemPriceWitOutTax;
      finalTax += itemPriceWitOutTax;
      // Append each item to cart UI
      cartWrapper.innerHTML += `
        <div class="cart-items" data-line="${item.key}" data-product-id="${item.product_id}" data-variant-id="${item.variant_id}" data-product-handle="${item.handle}" data-product-title="${item.title}">
          <div class="cart-image-wrapper" style="--bg-color: ${dishColor};">
            <div class="cart-items-image">
              <img src="${item.image}" alt="${item.title}" />
            </div>
          </div>
          <div class="cart-qty-box">            
            <div class="qty-box">
              <div class="quantity-selector-wrapper">
                <div class="cart-tag-wrapper">
                  <p class="cart-tag">Portionenanzahl</p>
                </div>
                <div class="quantity-selector">
                  <button class="qty-minus" data-action="decrease" data-line="${item.key}" style="${item.quantity <= 3 ? 'pointer-events:none;opacity:0.4;' : ''}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="2" viewBox="0 0 20 2">
                      <line y2="20" transform="translate(20 1) rotate(90)" fill="none" stroke="#35437c" stroke-width="2"></line>
                    </svg>
                  </button>
                  <div class="qty-txt">
                    <input type="text" name="cart-qty" value="${item.quantity}" />
                  </div>
                  <button class="qty-plus" data-action="increase" data-line="${item.key}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                      <g transform="translate(-1040.5 -1890.5)">
                        <line y2="20" transform="translate(1050.5 1890.5)" fill="none" stroke="#35437c" stroke-width="2"></line>
                        <line y2="20" transform="translate(1060.5 1900.5) rotate(90)" fill="none" stroke="#35437c" stroke-width="2"></line>
                      </g>
                    </svg>
                  </button>
                  <button class="remove-btn" data-line="${item.key}">
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 16 16">
                      <path d="M 6.496094 1 C 5.675781 1 5 1.675781 5 2.496094 L 5 3 L 2 3 L 2 4 L 3 4 L 3 12.5 C 3 13.324219 3.675781 14 4.5 14 L 10.5 14 C 11.324219 14 12 13.324219 12 12.5 L 12 4 L 13 4 L 13 3 L 10 3 L 10 2.496094 C 10 1.675781 9.324219 1 8.503906 1 Z M 6.496094 2 L 8.503906 2 C 8.785156 2 9 2.214844 9 2.496094 L 9 3 L 6 3 L 6 2.496094 C 6 2.214844 6.214844 2 6.496094 2 Z M 4 4 L 11 4 L 11 12.5 C 11 12.78125 10.78125 13 10.5 13 L 4.5 13 C 4.21875 13 4 12.78125 4 12.5 Z M 5 5 L 5 12 L 6 12 L 6 5 Z M 7 5 L 7 12 L 8 12 L 8 5 Z M 9 5 L 9 12 L 10 12 L 10 5 Z"></path>
                    </svg>
                  </button>
                </div>
              </div>              
            </div>
            <div class="cart-qty">
              <div class="signle-qty-cal">
                <span class="qty">${item.quantity} x</span>
                <span class="product-weight cal">${productWeight}</span>
              </div>
              <div class="totle-qty-cal">
                <span class="totle-cal cal">${parseFloat(productWeight) * item.quantity}g</span>
              </div>
            </div>
            <div class="cart-qty">
              <div class="signle-qty-cal">
                <span class="qty">${item.quantity} x</span>
                <span class="cart-item__price cal" data-tax-total="${finalTaxPriceTotal}" data-final-tax="${finalTaxPrice}" data-cart-total="${cart.total_price / 100}"  data-product-price ="${itemOrignalPrice}" data-product-price-old-versiont="${itemPriceWithTax.toFixed(2)}">€ ${(item.price / 100).toFixed(2).replace('.', ',')}</span>
              </div>
              <div class="totle-qty-cal">
                <span class="totle-cal cal price">€${(item.quantity * (item.price / 100)).toFixed(2).replace('.', ',')}</span>
              </div>
            </div>
          </div>
          <p class="cart-product-name">${item.title}</p>
        </div>
      `;
    });

    // Update cart count bubble
    const cartCountWrapper = document.querySelector('.cart-count-wrapper');
    const cartCountEl = document.querySelector('.b2c-cart-count .cart-item-count');
    if (cartCountEl) {
      cartCountEl.textContent = cart.item_count;

      if (cart.item_count > 0) {
        cartCountWrapper.classList.add('active');
      } else {
        cartCountWrapper.classList.remove('active');
      }
    }

    // Update total number of servings
    const totalNumberOfServings = activeTabContent.querySelector('.total-portion-count');
    totalNumberOfServings.textContent = totalPortions;

    // Update total weight 
    const totalWeightEl = activeTabContent.querySelector('.total-weight');
    const totalWeight = cart.items.reduce((acc, item) => {
      const productWeight = parseFloat(item.properties?._product_weight) || 0;
      return acc + (productWeight * item.quantity);
    }, 0);
    totalWeightEl.textContent = totalWeight + 'g';

    // Update total price
    const totalPriceEl = activeTabContent.querySelector('.total-price-info .total-price');
    if (totalPriceEl) {
      totalPriceEl.textContent = '€ ' + (cart.total_price / 100).toFixed(2).replace('.', ',');
    }

    // Update Shipping Cost based on number of portions
    const shippingEl = activeTabContent.querySelector('.shipping-cost span');
    let shippingCost = 0;
    // if (totalPortions >= 1 && totalPortions <= 50) {
    //   shippingCost = 10.59;
    // } else if (totalPortions >= 51 && totalPortions <= 100) {
    //   shippingCost = 17.52;
    // } else if (totalPortions >= 101 && totalPortions <= 125) {
    //   shippingCost = 24.90;
    // }

    if (totalPortions >= 1 && totalPortions <= 23) {
      shippingCost = 10.59;
      finalTax += 0.69;
    } else if (totalPortions >= 24 && totalPortions <= 50) {
      shippingCost = 10.59;
      finalTax += 0.34;
    } else if (totalPortions >= 51 && totalPortions <= 100) {
      shippingCost = 17.90;
      finalTax += 0.82;
    } else if (totalPortions >= 101 && totalPortions <= 125) {
      shippingCost = 24.90;
      finalTax += 1.28;
    }

    if (totalPortions >= 24) {
      shippingCost = Math.max(0, shippingCost - DISCOUNT);
    }

    shippingEl.textContent = shippingCost.toFixed(2).replace('.', ',');
    // Update Calculated Price
    const calculatedPriceEl = activeTabContent.querySelector('.total-price-info .calculated-price');
    // const calculatedPrice = (priceWithTax * totalPortions) + shippingCost;
    const calculatedPrice = (cart.total_price / 100) + shippingCost;
    calculatedPriceEl.textContent = calculatedPrice.toFixed(2).replace('.', ',');


    // Update VAT Tax
    const taxEl = activeTabContent.querySelector('.total-price-info.vat .tax-price');
    // const vatAmount = (cart.total_price / 100) * 0.07;
    const grossAmount1 = (cart.total_price / 100).toFixed(2);
    const netAmount = calculatedPrice / 1.07;
    // const vatAmount = grossAmount - (grossAmount / 1.07); 
    // const vatAmount = finalTaxPrice; 
    const vatAmount1 = (calculatedPrice - netAmount).toFixed(2);
    taxEl.textContent = vatAmount1.replace('.', ',');
    taxEl.setAttribute('data-final-tax-total', vatAmount1);

    // Update Progress bar logic
    const firstBarFill = Math.min(totalPortions, BAR_LIMIT);
    const firstBarPercent = (firstBarFill / BAR_LIMIT) * 100;

    const secondBarFill = Math.max(totalPortions - BAR_LIMIT, 0);
    const secondBarPercent = Math.min((secondBarFill / BAR_LIMIT) * 100, 100);

    minOrderProgress.style.width = `${firstBarPercent}%`;
    freeShippingProgress.style.width = `${secondBarPercent}%`;

    // Pending count text (how many to reach 12)
    portionRemaining = Math.max(BAR_LIMIT - totalPortions, 0)
    if (totalPortions < BAR_LIMIT) {
      progressPending.textContent = `Noch ${portionRemaining} Portionen bis zur Mindestbestellmenge`;
    } else if (totalPortions === BAR_LIMIT) {
      progressPending.textContent = 'Mindestbestellmenge erreicht!';
    } else {
      const portionsToFreeShipping = SHIPPING_LIMIT - totalPortions;
      if (portionsToFreeShipping > 0) {
        progressPending.textContent = `Sie sind nur noch ${portionsToFreeShipping} Portionen von dem Versandkostenrabatt entfernt.`;
      } else {
        progressPending.textContent = 'Glückwunsch! 5€ Versandrabatt erhalten.';
      }
    }

    // Enable or disable ATC button based on minimum order
    const actBtn = activeTabContent.querySelector('.atc-btn');
    actBtn?.classList.toggle('active', totalPortions >= BAR_LIMIT);

    // Free shipping when 24 portions reached
    document.body.classList.toggle('free-shipping-active', totalPortions >= BAR_LIMIT * 2);

    // reinitialize carousel if cart item count empty
    if (cart.items.length === 0) {
      const carousel = document.querySelector('.carousel');
      const activeTab = document.querySelector('.tab.active');
      const tabIndex = activeTab?.dataset.tab;

      if (carousel?.flickityInstance) {
        carousel.flickityInstance.destroy();
        carousel.flickityInstance = null;
      }

      carousel?.classList.remove('no-slider');
      initCarousel(carousel, tabIndex);

      // Remove cart-has-item class from all tabs when cart is empty
      document.querySelectorAll('.tab').forEach(t => t.classList.remove('cart-has-item'));
    }

    activeTabContent.querySelectorAll('.product-cta.active').forEach(cta => {
      const variantId = cta.dataset.variantId;
      const cartItem = cart.items.find(item => String(item.variant_id) === String(variantId));
      if (cartItem) {
        const minusBtn = cta.querySelector('.button-minus');
        if (minusBtn) {
          if (cartItem.quantity <= 3) {
            minusBtn.style.pointerEvents = 'none';
            minusBtn.style.opacity = '0.4';
          } else {
            minusBtn.style.pointerEvents = 'auto';
            minusBtn.style.opacity = '1';
          }
        }
      }
    });

    // // Updating mobile info cta 
    const mobileInfoCTA = activeTabContent.querySelectorAll('.popup-mobile-info-cta span');
    if (mobileInfoCTA.length > 1) mobileInfoCTA[1].textContent = cart.item_count;
  } catch (error) {
    console.error('Error updating cart UI:', error);
  }
}

async function clearCart() {
  try {
    const response = await fetch('/cart/clear.js', {
      method: 'POST'
    });

    if (!response.ok) {
      throw new Error('Failed to clear cart');
    }

    updateCartUI();
  } catch (error) {
    console.error(error);
  }
}

// Change cart item quantity
async function changeCartItemQuantity(line, quantity) {
  try {
    let oldQty = 0;
    let item = null;
    try {
      const preRes = await fetch('/cart.js');
      if (preRes.ok) {
        const preCart = await preRes.json();
        item = preCart.items.find(i => String(i.key) === String(line) || String(i.variant_id) === String(line) || String(i.id) === String(line));
        if (item) {
          oldQty = parseInt(item.quantity, 10);
        }
      }
    } catch (err) {
      console.error('Error fetching pre-change cart:', err);
    }

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line, quantity })
    });

    if (!response.ok) {
      throw new Error('Failed to update quantity');
    }

    await updateCartUI();

    if (item) {
      const diff = quantity - oldQty;
      if (diff !== 0) {
        const itemPrice = parseFloat(item.price) / 100;
        const diffValue = (itemPrice * Math.abs(diff)).toFixed(2);

        const payloadItem = {
          item_id: (item.variant_id || item.id).toString(),
          item_name: item.product_title || item.title,
          price: itemPrice.toFixed(2),
          quantity: Math.abs(diff)
        };

        const payload = {
          currency: 'EUR',
          value: diffValue,
          items: [payloadItem]
        };

        if (diff > 0) {
          if (typeof window.chinukiTrack === 'function') {
            window.chinukiTrack('add_to_cart', payload);
          }
        } else {
          if (typeof window.chinukiTrack === 'function') {
            window.chinukiTrack('remove_from_cart', payload);
          }
        }
      }
    }
  } catch (error) {
    console.error('Error updating cart quantity:', error);
  }
}

// ====================== Header Icon redirect to dish picker section & open cart  ======================
document.addEventListener('click', async function (e) {
  const cartIconLink = e.target.closest('a[href="#dish-picker"]');
  if (!cartIconLink) return;

  const loginPopup = cartIconLink.closest('.b2c-login-popup');

  e.preventDefault();

  if (loginPopup) {
    loginPopup.classList.remove('popup-is-open');
    loginPopup.style.display = 'none';
  }

  const dishPickerSection = document.getElementById('dish-picker');
  if (dishPickerSection) {
    dishPickerSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  setTimeout(async () => {
    const activeContent = document.querySelector('.tab-content.active');
    console.log('Active content:', activeContent);
    if (!activeContent) return;
    const carousel = activeContent.querySelector('.carousel');
    if (!carousel) return;
    if (carousel.classList.contains('no-slider')) return;

    if (carousel?.flickityInstance) {
      carousel.dataset.restoreIndex = carousel.flickityInstance.selectedIndex;
      carousel.flickityInstance.destroy();
      carousel.flickityInstance = null;
    }
    activeContent.querySelector('.tab-cta')?.classList.add('hidden');
    carousel?.classList.add('no-slider');
    document.body.classList.add('show-ingredient');
  }, 200);
});

document.addEventListener('click', async (e) => {
  const orderBtn = e.target.closest('.atc-btn.active');
  if (!orderBtn) return;

  try {
    const res = await fetch('/cart.js');
    if (!res.ok) throw new Error(`Failed to fetch cart: ${res.status}`);

    const cartData = await res.json();

    const items = cartData.items.map(item => {
      const rawWeight = item.properties?._product_weight || '0g';
      const rawPrice = item.properties?._product_price;
      const priceWithTax = rawPrice && !isNaN(parseFloat(rawPrice)) ? rawPrice : ((item.price / 100) * 1.07).toFixed(2);

      // Remove 'g' and convert to number
      const baseWeight = parseFloat(rawWeight.replace('g', '').trim()) || 0;

      return {
        quantity: item.quantity,
        price: item.price,
        price_with_tax: priceWithTax,
        variant_id: item.variant_id,
        title: item.title,
        line_price: item.line_price,
        sku: item.sku,
        product_id: item.product_id,
        product_weight: baseWeight * item.quantity + 'g'
      };
    });

    console.log(items);

    const activeTabContent = document.querySelector('.tab-content.active');
    const totalPOrtionsEl = activeTabContent.querySelector('.total-portion-count');
    const totalPortions = parseInt(totalPOrtionsEl.textContent, 10);

    const shippingEl = activeTabContent.querySelector('.shipping-cost span');
    const shippingCost = parseFloat(shippingEl.textContent.replace(',', '.'));

    const net_amount = parseFloat(activeTabContent.querySelector('.cart-item__price').dataset.cartTotal);
    // const vatAmount = net_amount * 0.07;
    const vatAmount = parseFloat(activeTabContent.querySelector('.cart-item__price').dataset.taxTotal);
    const vat_amount_2 = parseFloat(activeTabContent.querySelector('.total-price-info.vat .tax-price').getAttribute('data-final-tax-total'));
    const deviceBtn = document.querySelector('.sources-btn.selected');
    const deviceValue = deviceBtn ? deviceBtn.getAttribute('data-popup') : null;

    const deliveryDate = document.querySelector('.tab.active').dataset.deliveryDate;

    const payload = {
      items,
      shipping_cost: shippingCost,
      vat_amount: vatAmount,
      vat_amount_2: vat_amount_2,
      gross_total: net_amount + vatAmount,
      total_portions: totalPortions,
      device_option: deviceValue,
      delivery_date: deliveryDate
    };

    if (typeof window.chinukiAddToCartTracking === 'function') {
      window.chinukiAddToCartTracking(cartData, function (updatedCart, gclid) {
        if (typeof window.chinukiGetGA4SessionParams === 'function') {
          window.chinukiGetGA4SessionParams(function (clientId, sessionId) {
            if (sessionId) payload.session_id = sessionId;
            const encodedCart = btoa(JSON.stringify(payload));
            var finalUrl = `${window.ChinukiConfig.apiBaseUrl}/b2c/cart/?token=${encodedCart}`;
            if (gclid) finalUrl += '&gclid=' + encodeURIComponent(gclid);
            if (clientId) finalUrl += '&client_id=' + encodeURIComponent(clientId);
            window.location.href = finalUrl;
          });
        } else {
          const encodedCart = btoa(JSON.stringify(payload));
          var finalUrl = `${window.ChinukiConfig.apiBaseUrl}/b2c/cart/?token=${encodedCart}` + (gclid ? '&gclid=' + encodeURIComponent(gclid) : '');
          window.location.href = finalUrl;
        }
      });
    } else {
      if (typeof window.chinukiGetGA4SessionParams === 'function') {
        window.chinukiGetGA4SessionParams(function (clientId, sessionId) {
          if (sessionId) payload.session_id = sessionId;
          const encodedCart = btoa(JSON.stringify(payload));
          var finalUrl = `${window.ChinukiConfig.apiBaseUrl}/b2c/cart/?token=${encodedCart}`;
          if (clientId) finalUrl += '&client_id=' + encodeURIComponent(clientId);
          window.location.href = finalUrl;
        });
      } else {
        const encodedCart = btoa(JSON.stringify(payload));
        window.location.href = `${window.ChinukiConfig.apiBaseUrl}/b2c/cart/?token=${encodedCart}`;
      }
    }
  } catch (err) {
    console.error('Error fetching cart:', err);
  }
});

loadDeliveryWeeks();